import type { LayoutRow, LayoutCatalog, RowType, Visibility } from '../types'

const COLUMNS = ['gemeinde', 'kreis', 'land', 'bund'] as const

interface Props {
  row: LayoutRow
  catalog: LayoutCatalog
  onChange: (row: LayoutRow) => void
  onRemove: () => void
}

export function LayoutRowForm({ row, catalog, onChange, onRemove }: Props) {
  const set = (patch: Partial<LayoutRow>) => onChange({ ...row, ...patch })
  return (
    <div className="bg-gut8-bg-muted border border-border-gut8-light rounded-gut8 p-3 space-y-2">
      <div className="flex gap-2 items-center">
        <input className="flex-1 px-3 py-2 text-sm border border-border-gut8-medium rounded-gut8 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" placeholder="Label" value={row.label}
               onChange={(e) => set({ label: e.target.value })} />
        <button className="text-sm text-secondary hover:opacity-80" onClick={onRemove}>Entfernen</button>
      </div>
      <div className="flex gap-2 flex-wrap">
        <input className="flex-1 px-3 py-2 text-sm border border-border-gut8-medium rounded-gut8 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" placeholder="source (z.B. makro_field:unemployment_rate)"
               value={row.source ?? ''} onChange={(e) => set({ source: e.target.value })} />
        <select className="px-3 py-2 text-sm border border-border-gut8-medium rounded-gut8 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" value={row.row_type}
                onChange={(e) => set({ row_type: e.target.value as RowType })}>
          {catalog.row_types.map((rt) => <option key={rt} value={rt}>{rt}</option>)}
        </select>
        <input className="w-20 px-3 py-2 text-sm border border-border-gut8-medium rounded-gut8 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" type="number" placeholder="dec"
               value={row.decimals ?? 2} onChange={(e) => set({ decimals: Number(e.target.value) })} />
        <select className="px-3 py-2 text-sm border border-border-gut8-medium rounded-gut8 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" value={row.visibility ?? 'both'}
                onChange={(e) => set({ visibility: e.target.value as Visibility })}>
          <option value="both">both</option><option value="web">web</option><option value="prompt">prompt</option>
        </select>
      </div>
      <div className="flex gap-3 items-center text-sm text-gut8-anthracite">
        {COLUMNS.map((c) => (
          <label key={c} className="flex items-center gap-1">
            <input type="checkbox" checked={(row.columns ?? []).includes(c)}
                   onChange={(e) => set({ columns: e.target.checked
                     ? [...(row.columns ?? []), c]
                     : (row.columns ?? []).filter((x) => x !== c) })} />
            {c}
          </label>
        ))}
        <label className="flex items-center gap-1">
          <input type="checkbox" checked={!!row.hide_if_empty}
                 onChange={(e) => set({ hide_if_empty: e.target.checked })} /> hide_if_empty
        </label>
      </div>
    </div>
  )
}
